
export class ParseCurrencyMobile{
    public static parse(value){
        try{
            const income = value.replace('.', '').replace(',', '.').replace(/\D/g, '');
            return [income?.slice(0, -2), '.', income?.slice(-2)].join('');
        }
        catch (err){
            return value;
        }
    }
}